<template>
    <div
        class="pointer-helper"
        ref="helper"
    >
        <span class="decoration"></span>
        <span class="caption">{{ caption }}</span>
    </div>
</template>
<script>
import { locations } from '@/store/index.js'
export default {
    props: {
        caption: {
            type: String
        }
    },
    computed: {
        idx() {
            return locations.idx
        },
        position() {
            return locations.helper
        }
    },
    watch: {
        position(pos) {
            this.$refs.helper.style.transform = `translateX(${pos.x}px) translateY(${-pos.y}px)`
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"

.pointer-helper
    position: absolute
    left: 50%
    top: 50%
    display: flex
    z-index: 1
    // justify-content: center
    align-items: center
    height: 1px
    width: 1px
    .decoration
        width: 21px
        height: 21px
        position: absolute
        left: -10px
        background-color: #ff2b2a
        display: block
        &:before
            content: ""
            width: 11px
            height: 1px
            background-color: white
            position: absolute
            top: 10px
            left: 5px
        &:after
            content: ""
            width: 1px
            height: 11px
            background-color: white
            position: absolute
            top: 5px
            left: 10px

    .caption
        display: block
        margin-left: 24px
        font-weight: 500
        color: #ff2b2a
        white-space: nowrap
    &.v-enter-active,
    &.v-leave-active
        transition: opacity .3125s
    &.v-enter,
    &.v-leave-to
        opacity: 0
</style>
